import { Component } from '@angular/core';
import { LoaderService } from 'src/app/core/services/app/loader.service';

@Component({
	selector: 'app-loader',
	templateUrl: './loader.component.html',
	styleUrl: './loader.component.less'
})
export class LoaderComponent {
	showLoader: boolean = false;
	showSpinner: boolean = false;

	constructor(private loaderService: LoaderService) { }

	ngOnInit(): void {
		this.loaderService.showLoader$.subscribe(l => this.showLoader = l);
	}
}
